import { queryTaskReport,queryTaskUser,subsReports,cancelReport } from "../../api/config/modules/ReportPush";

const state = {
    queryTaskReport: {},
    queryTaskUser: {},
    subsReports: {},
    cancelReport: {},
};

const mutations = {
  SET_QUERYTASKREPORT: (state, queryTaskReport) => {
    state.queryTaskReport = queryTaskReport;
  },
  SET_QUERYTASKUSER: (state, queryTaskUser) => {
    state.queryTaskUser = queryTaskUser;
  },
  SET_SUBSREPORTS: (state, subsReports) => {
    state.subsReports = subsReports;
  },
  SET_CANCELREPORT: (state, cancelReport) => {
    state.cancelReport = cancelReport;
  },
};

const actions = {
  GET_QUERYTASKREPORT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryTaskReport(data)
        .then((res) => {
          commit("SET_QUERYTASKREPORT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_QUERYTASKUSER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryTaskUser(data)
        .then((res) => {
          commit("SET_QUERYTASKUSER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SUBSREPORTS: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        subsReports(data)
        .then((res) => {
          commit("SET_SUBSREPORTS", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_CANCELREPORT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        cancelReport(data)
        .then((res) => {
          commit("SET_CANCELREPORT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
